module.exports = __webpack_public_path__ + "img/slider-circle.22e36297.png";